import { getBlob } from "@/helpers/apiRequest";

export const ATRASO_LIBERACAO_URL = 1000;

const decodificar = (valor) => {
  try {
    return decodeURIComponent(valor);
  } catch (erro) {
    return null;
  }
};

const semAspas = (valor) => valor.trim().replace(/^"(.*)"$/, "$1").trim();

export function nomeDoArquivo(contentDisposition, nomePadrao) {
  const cabecalho = String(contentDisposition || "");
  const estendido = cabecalho.match(/filename\*\s*=\s*([^;]+)/i);

  if (estendido) {
    const nome = decodificar(semAspas(estendido[1]).replace(/^[^']*'[^']*'/, ""));

    if (nome) return nome;
  }

  const simples = cabecalho.match(/filename\s*=\s*("[^"]*"|[^;]*)/i);
  const nome = simples ? semAspas(simples[1]) : "";

  return nome || nomePadrao;
}

export function salvarBlob(blob, nome) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = nome;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), ATRASO_LIBERACAO_URL);
}

export async function salvarResposta(response, nomePadrao) {
  const blob = await response.blob();
  const nome = nomeDoArquivo(response.headers.get("Content-Disposition"), nomePadrao);

  salvarBlob(blob, nome);

  return nome;
}

export async function downloadBlob(url, nomePadrao) {
  return salvarResposta(await getBlob(url), nomePadrao);
}
